import { TableCell, tableCellClasses, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: theme?.palette?.bgLightWhite?.main,
    fontSize: 14,
    // fontWeight: "bold",
    textAlign: "center", // Horizontally align content,
    lineHeight: '1.2rem',
    borderRight:"1px solid rgba(248, 248, 248, 0.2)",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    // padding: '15px 10px !important',
    textAlign: "center", // Horizontally align content
    borderBottom: "none",
    borderBottom:`1px solid lightgrey`
  },
}));
export default StyledTableCell;
